module.exports = __webpack_public_path__ + "img/fur-black.71107472.svg";